const errorParser = (err) => {
  const { data } = err
  if (!data) {
    return {}
  }
  const { statusCode, errors } = data

  const messages = errors.map((error) => error.message)
  const message = messages[0]

  return {
    message,
    messages,
    statusCode,
    errors,
  }
}

export const setError = (err) => {
  const msg = errorParser(err)
  const newErr = { ...err, ...msg }
  return newErr
}

export default { setError }
